import { createUseStyles } from 'react-jss';
import { visuallyHidden } from '@wds/utils';

const useStyles = createUseStyles((theme) => {
  const { pane } = theme;
  return {
    wdsPane: ({ hide, transparent }) => ({
      ...(hide && visuallyHidden),
      background: transparent ? 'none' : pane.bgColor,
    }),

    wdsPaneBody: () => ({
      padding: pane.padding,
    }),
  };
});

export default useStyles;
